(() => {
const locations = [
    {
        "name": "Canales Furniture Matlock Showroom",
        "short": "Matlock Showroom",
        "address": "102 E Interstate 20, Arlington, TX 76018",
        "lat": 32.6768119,
        "lon": -97.1162964,
        "pageUrl": "/pages/arlington-matlock-1"
    },
    {
        "name": "Canales Furniture Rockwall",
        "short": "Rockwall",
        "address": "1023 E Interstate 30, Rockwall, TX 75032",
        "lat": 32.9038371,
        "lon": -96.4519656,
        "pageUrl": "/pages/rockwall"
    },
    {
        "name": "Canales Furniture Terrell",
        "short": "Terrell",
        "address": "1404 W Moore Ave, Terrell, TX 75160",
        "lat": 32.7398125,
        "lon": -96.3012837,
        "pageUrl": "/pages/terrell-1"
    },
    {
        "name": "Canales Furniture Waco",
        "short": "Waco",
        "address": "4905 W Waco Dr, Waco, TX 76710",
        "lat": 31.53155,
        "lon": -97.18434,
        "pageUrl": "/pages/waco-dr"
    },
    {
        "name": "Canales Furniture Corsicana",
        "short": "Corsicana",
        "address": "836 W 7th Ave, Corsicana, TX 75110",
        "lat": 32.0879434,
        "lon": -96.4744464,
        "pageUrl": "/pages/corsicana-1"
    },
    {
        "name": "Canales Furniture Oklahoma City",
        "short": "Oklahoma City",
        "address": "1616 W I-240 Service Rd, Oklahoma City, OK 73159",
        "lat": 35.3869795,
        "lon": -97.6277558,
        "pageUrl": "/pages/oklahoma-city"
    },
    {
        "name": "Canales Furniture Weatherford",
        "short": "Weatherford",
        "address": "735 Adams Dr, Weatherford, TX 76086",
        "lat": 32.7331709,
        "lon": -97.785937,
        "pageUrl": "/pages/weatherford-1"
    },
    {
        "name": "Canales Furniture Mesquite",
        "short": "Mesquite",
        "address": "2021 N Town E Blvd, Mesquite, TX 75150",
        "lat": 32.8127,
        "lon": -96.6333,
        "pageUrl": "/pages/mesquite-1"
    },
    {
        "name": "Canales Furniture North Richland Hills",
        "short": "North Richland Hills",
        "address": "5555 Rufe Snow Dr, Suite 390, North Richland Hills, TX 76180",
        "lat": 32.847696,
        "lon": -97.2416588,
        "pageUrl": "/pages/north-richland-hills-1"
    },
    {
        "name": "Canales Furniture Harry Hines",
        "short": "Harry Hines",
        "address": "10220 Harry Hines Blvd, Dallas, TX 75220",
        "lat": 32.8623625,
        "lon": -96.8829132,
        "pageUrl": "/pages/harry-hines-1"
    },
    {
        "name": "Canales Furniture Oak Cliff",
        "short": "Oak Cliff",
        "address": "101 E Jefferson Blvd, Dallas, TX 75203",
        "lat": 32.7476,
        "lon": -96.8225,
        "pageUrl": "/pages/oak-cliff"
    },
    {
        "name": "Canales Furniture Arlington Abram",
        "short": "Arlington Abram",
        "address": "2002 E Abram St, Arlington, TX 76010",
        "lat": 32.7344325,
        "lon": -97.0795373,
        "pageUrl": "/pages/arlington-abram-st"
    },
    {
        "name": "Canales Furniture Duncanville",
        "short": "Duncanville",
        "address": "7320 S Cockrell Hill Rd, Dallas, TX 75236",
        "lat": 32.6585,
        "lon": -96.8914,
        "pageUrl": "/pages/duncanville-1"
    },
    {
        "name": "Canales Furniture North Dallas",
        "short": "North Dallas",
        "address": "7879 Spring Valley Rd #108, Dallas, TX 75254",
        "lat": 32.940378,
        "lon": -96.770535,
        "pageUrl": "/pages/north-dallas"
    },
    {
        "name": "Canales Furniture Waxahachie",
        "short": "Waxahachie",
        "address": "600 N Hwy 77, Waxahachie, TX 75165",
        "lat": 32.409001,
        "lon": -96.8436676,
        "pageUrl": "/pages/waxahachie-1"
    },
    {
        "name": "Canales Furniture Irving",
        "short": "Irving",
        "address": "3560 W Airport Freeway, Irving, TX 75062",
        "lat": 32.8354689,
        "lon": -96.9998718,
        "pageUrl": "/pages/irving-1"
    },
    {
        "name": "Canales Furniture La Gran Plaza",
        "short": "La Gran Plaza",
        "address": "4200 South Fwy #1118 & #1128, Fort Worth, TX 76115",
        "lat": 32.6877079,
        "lon": -97.3269683,
        "pageUrl": "/pages/fort-worth-lgp"
    },
    {
        "name": "Canales Furniture Garland",
        "short": "Garland",
        "address": "3161 Broadway Blvd #98 & #111, Garland, TX 75043",
        "lat": 32.8766673,
        "lon": -96.6242641,
        "pageUrl": "/pages/garland-1"
    },
    {
        "name": "Canales Furniture Plano",
        "short": "Plano",
        "address": "2404 K Ave, Plano, TX 75074",
        "lat": 33.0298516,
        "lon": -96.7006775,
        "pageUrl": "/pages/plano"
    }
];
const GEO_CACHE_KEY = 'cf_geo_v2';
const GEO_CACHE_TTL = 15 * 60 * 1000;
const GEO_TIMEOUT = 8000;
const GEO_MAX_AGE = 5 * 60 * 1000;
// One request shared by desktop/mobile instances on this page.
let cfGeoRequest = null;
function validCoords(lat, lon) {
  return Number.isFinite(lat) && Number.isFinite(lon) &&
    Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
}
class LocationPoint extends HTMLElement {
    constructor() {
        super();
        const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
        const isEs = htmlLang.indexOf('es') === 0;
        this.isEs = isEs;
        this.locationTitle = isEs ? 'Encuentra tu tienda local' : 'Find your local showroom';
        this.seeAllText = isEs ? 'Ver tiendas' : 'See showrooms';
        this.stores = locations;
        this.locationsUrl = this.getAttribute('data-locations-url') || '/pages/locations';
    }
    connectedCallback() {
       this.locationsUrl = this.getAttribute('data-locations-url') || '/pages/locations';
       this.dataset.locationState = 'default';
       this.renderStoreInfo(this.stores[0]);
       this.fetchUserLocation((latitude, longitude) => {
           if (!this.isConnected || !validCoords(latitude, longitude)) return;
           this.dataset.locationState = 'detected';
           this.renderStoreInfo(this.findClosestStore(latitude, longitude));
       });
   }
   readGeoCache() {
        try {
            const raw = window.sessionStorage.getItem(GEO_CACHE_KEY);
            if (!raw) return null;
            const data = JSON.parse(raw);
            const isValid =
                data &&
                validCoords(data.lat, data.lon) && Number.isFinite(data.ts) && data.ts <= Date.now();
            if (!isValid) return null;
            if (Date.now() - data.ts > GEO_CACHE_TTL) {
                window.sessionStorage.removeItem(GEO_CACHE_KEY);
                return null;
            }
            return data;
        } catch (e) {
            return null;
        }
    }
    writeGeoCache(lat, lon) {
        try {
            window.sessionStorage.setItem(
                GEO_CACHE_KEY,
                JSON.stringify({ lat: lat, lon: lon, ts: Date.now() })
            );
        } catch (e) {
            // sessionStorage no disponible (modo privado / cookies bloqueadas)
        }
    }
    fetchUserLocation(callback) {
       const cached = this.readGeoCache();
       if (cached) {
           callback(cached.lat, cached.lon);
           return;
       }
       if (!navigator.geolocation) return;
       if (!cfGeoRequest) {
           cfGeoRequest = new Promise((resolve) => {
               let finished = false;
               let timer;
               const finish = (coords) => {
                   if (finished) return;
                   finished = true;
                   clearTimeout(timer);
                   resolve(coords);
               };
               // Bounds UI waiting even if the permission prompt is unanswered.
               timer = setTimeout(() => finish(null), GEO_TIMEOUT);
               try {
                   navigator.geolocation.getCurrentPosition(
                       (position) => {
                           const { latitude: lat, longitude: lon } = position.coords;
                           finish(validCoords(lat, lon) ? { lat, lon } : null);
                       },
                       () => finish(null),
                       { timeout: GEO_TIMEOUT, maximumAge: GEO_MAX_AGE, enableHighAccuracy: false }
                   );
               } catch (error) {
                   finish(null);
               }
           });
       }
       cfGeoRequest.then((coords) => {
           if (!coords) return;
           this.writeGeoCache(coords.lat, coords.lon);
           callback(coords.lat, coords.lon);
       });
   }
    getStoreUrl(store) {
        const root = (this.getAttribute('data-root-url') || '/').replace(/\/+$/, '');
        return root + store.pageUrl;
    }
    haversineDistance(lat1, lon1, lat2, lon2) {
        const R = 3958.8;
        const p1 = lat1 * Math.PI / 180;
        const p2 = lat2 * Math.PI / 180;
        const deltaP = p2 - p1;
        const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;
        const a =
            Math.sin(deltaP / 2) * Math.sin(deltaP / 2) +
            Math.cos(p1) * Math.cos(p2) *
            Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
        return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(Math.max(0, 1 - a))) * R;
    }
    findClosestStore(userLat, userLon) {
        const ranked = this.stores.map((store) => ({
            ...store,
            distance: this.haversineDistance(userLat, userLon, store.lat, store.lon)
        }));
        return ranked.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));
    }
    renderStoreInfo(store) {
        this.removeAttribute('aria-label');
        this.locationTitle = this.dataset.locationState === 'detected'
            ? (this.isEs ? 'Tu ubicación más cercana' : 'Your nearest location')
            : (this.isEs ? 'Ubicación predeterminada' : 'Default location');
        const title = document.createElement('div');
        title.textContent = this.locationTitle;
        const addressRow = document.createElement('div');
        const link = document.createElement('a');
        link.className = 'cf-location-address';
        link.href = this.getStoreUrl(store);
        link.setAttribute('aria-label', `${store.address} — ${this.isEs ? 'Ver tienda' : 'View store'}: ${store.name}`);
        const strong = document.createElement('strong');
        strong.textContent = store.address;
        link.append(strong);
        addressRow.append(link);
        const allRow = document.createElement('div');
        const allLink = document.createElement('a');
        allLink.href = this.locationsUrl;
        allLink.textContent = this.seeAllText;
        allRow.append(allLink);
        this.replaceChildren(title, addressRow, allRow);
    }

}
if (!customElements.get('location-point')) {
    customElements.define('location-point', LocationPoint);
}
})();

